export interface SentenceCaseOptions {
  /** When true, lowercases the remainder of the string (strict sentence case).
   *  When false (default), preserves the original casing of the tail. */
  lowercaseRest?: boolean;
}

export function toSentenceCase(str: string, options?: SentenceCaseOptions): string {
  if (!str) return str;
  const rest = options?.lowercaseRest ? str.slice(1).toLowerCase() : str.slice(1);
  return str.charAt(0).toUpperCase() + rest;
}
